import { combineReducers, configureStore } from "@reduxjs/toolkit";

// Auth slices
import authSlice from "../slices/auth/authSlice";
import settingSlice from "../slices/auth/settingSlice";

// Common slices
import companyAndBrandSlice from "../slices/common/companyAndBrandSlice";
import companyIntegrationSlice from "../slices/common/companyIntegrationSlice";
import customDomainSlice from "../slices/common/customDomainSlice";
import marketingSlice from "../slices/common/marketingSlice";
import seoSlice from "../slices/common/seoSlice";
import subscriptionSlice from "../slices/common/subscriptionSlice";
import tenantSlice from "../slices/common/tenantSlice";
import websiteInfoSlice from "../slices/common/websiteInfoSlice";
import websiteMetaDataSlice from "../slices/common/websiteMetaDataSlice";

// Ecommerce slices
import adminNotifictionSlice from "../slices/ecommerce/adminNotifictionSlice";
import arShapesSlice from "../slices/ecommerce/arShapesSlice";
import couponSlice from "../slices/ecommerce/couponSlice";
import customerSlice from "../slices/ecommerce/customerSlice";
import dashboardSlice from "../slices/ecommerce/dashboardSlice";
import deliveryChargeSlice from "../slices/ecommerce/deliveryChargeSlice";
import inventorySlice from "../slices/ecommerce/inventorySlice";
import offeringSlice from "../slices/ecommerce/offeringSlice";
import orderSlice from "../slices/ecommerce/orderSlice";
import ProductCustomerReviewSlice from "../slices/ecommerce/ProductCustomerReviewSlice";
import productCategorySlice from "../slices/ecommerce/productCategorySlice";
import productFilterSlice from "../slices/ecommerce/productFilterSlice";
import productSlice from "../slices/ecommerce/productSlice";

// Legacy/root slices
import categoryDataSlice from "../slices/categoryDataSlice";
import citySlice from "../slices/citySlice";
import eventSlice from "../slices/eventSlice";
import loginSlice from "../slices/loginSlice";
import notificationSlice from "../slices/notificationSlice";
import rewardSlice from "../slices/rewardSlice";
import storySlice from "../slices/storySlice";
import subCategorySlice from "../slices/subCategorySlice";
import twilioSlice from "../slices/twilioSlice";
import UserManagementSlice from "../slices/UserManagementSlice";

const combinedReducer = combineReducers({
  // Auth reducers
  auth: authSlice,
  setting: settingSlice,
  login: loginSlice,
  notification: notificationSlice,

  // Common reducers
  tenant: tenantSlice,
  companyBrand: companyAndBrandSlice,
  companyIntegration: companyIntegrationSlice,
  marketing: marketingSlice,
  seo: seoSlice,
  website: websiteInfoSlice,
  customDomain: customDomainSlice,
  subscription: subscriptionSlice,
  websiteMetaData: websiteMetaDataSlice,

  // Ecommerce reducers
  dashboard: dashboardSlice,
  product: productSlice,
  review: ProductCustomerReviewSlice,
  coupon: couponSlice,
  order: orderSlice,
  arShapes: arShapesSlice,
  adminNotification: adminNotifictionSlice,
  customer: customerSlice,
  productCategory: productCategorySlice,
  productFilter: productFilterSlice,
  offering: offeringSlice,
  inventory: inventorySlice,
  deliveryCharge: deliveryChargeSlice,

  // Legacy/root reducers
  reward: rewardSlice,
  story: storySlice,
  users: UserManagementSlice,
  event: eventSlice,
  twilio: twilioSlice,
  categoryData: categoryDataSlice,
  subCategory: subCategorySlice,
  city: citySlice,
});

const rootReducer = (state, action) => {
  if (action.type === "login/setLoginFlag") {
    // check for action type
    state = undefined;
  }
  return combinedReducer(state, action);
};

const store = configureStore({
  reducer: rootReducer,
});

export default store;
